import React, { useState }  from "react";
import "./About.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import image from "../assets/img22.png";
import { FaCheck} from "react-icons/fa";
// Import three images for the three-column section
import img1 from "../assets/9.jpg";
import img2 from "../assets/10.jpg";
import img3 from "../assets/10.png";
import faqImage from "../assets/5.png"; // Add an image for FAQ section

const About = () => {

    
    // FAQ Accordion State
    const [activeIndex, setActiveIndex] = useState(0); // First question open by default

const toggleAccordion = (index) => {
    setActiveIndex(prevIndex => (prevIndex === index ? null : index)); // Allow toggling
};

const faqData = [
    { question: "How secure is Globus Trading?", answer: "Globus Trading is a premier forex brokerage offering a comprehensive suite of trading tools and resources, including web-based, desktop, and mobile trading platforms to help traders achieve their financial goals." },
    { question: "How do I open an account with Globus Trading?", answer: "Opening an account is simple. Visit our website, click on the ‘Open Account’ button, and follow the prompts to complete the registration process. You’ll need to provide some basic information and verify your identity." },
    { question: "What trading platforms does Globus Trading offer?", answer: "We offer three powerful trading platforms: the Globus Web Trader for browser-based trading, the Globus Trading Terminal for desktop trading, and the Globus Trading Mobile App for trading on the go." },
    { question: "What support does Globus Trading offer to traders?", answer: "We provide 24/5 customer support through live chat, email, and phone. Additionally, our platform offers educational resources, market analysis, and trading insights to help you make informed decisions." }
];
    return (
        <>
            <Navbar />
            
            {/* About Us Section */}
            <div className="about-section">
                <h2 className="about-title">About Us</h2>
            </div>

            <div className="two-column-section">
                <div className="column-left">
                    <img src={image} alt="Forex Trading" className="trading-image" />
                </div>
                <div className="column-right">
                    <h2>About Us</h2>
                    <p>
                        Globus is a premier brokerage platform globally renowned for its dedication to delivering 
                        cutting-edge solutions through superior tools and analytics. Our paramount objective is to 
                        offer clients the ultimate trading experience, presenting a robust suite of user-friendly 
                        tools crafted to accommodate traders of every proficiency level. Globus operates as a fully 
                        licensed and regulated brokerage, guaranteeing utmost security and compliance.
                    </p>
                    <a className="btn secondary" href="https://cabinet.globustrading.co/register">
                            Create Account ➜
                        </a>
                </div>
            </div>

            {/* Three-Column Section */}
            <div className="three-column-section">
                <div className="column">
                    <img src={img1} alt="Why Choose Us" />
                    <h3>Why Choose Us</h3>
                    <p>Anyone can start their trading journey with Globus Trading. GT offers world-class execution, 
                    advanced analytics, and a range of tools designed for traders of all skill levels.</p>
                </div>

                <div className="column">
                    <img src={img2} alt="Award-Winning Brokerage Services" />
                    <h3>Award-Winning Brokerage Services</h3>
                    <p>Globus Trading is recognized for providing excellent services, offering innovative tools and 
                    analytics to help traders succeed in their financial journey.</p>
                </div>

                <div className="column">
                    <img src={img3} alt="Why Do People Choose GT?" />
                    <h3>Why Do People Choose GT?</h3>
                    <p>With a commitment to security, transparency, and ease of use, GT remains a top choice for traders 
                    worldwide, providing access to global markets.</p>
                </div>
            </div>

             {/* Four-Column Section with Icons Aligned to the Right */}
             <div className="four-column-section">
                <div className="column2">
                    <div className="column-content">
                        <div className="icon-box">
                            <FaCheck className="icon" />
                        </div>
                        <div className="text">
                            <h3>Multi-Asset Platform</h3>
                            <p>Trade over 10,000 instruments covering stocks, crypto, forex, commodities and more</p>
                        </div>
                    </div>
                </div>

                <div className="column2">
                    <div className="column-content">
                        <div className="icon-box">
                            <FaCheck className="icon" />
                        </div>
                        <div className="text">
                            <h3>Top Shelf Trading Environment</h3>
                            <p>Enjoy top-shelf trading conditions, with costs that beat 80% of our peers</p>
                        </div>
                    </div>
                </div>

                <div className="column2">
                    <div className="column-content">
                        <div className="icon-box">
                            <FaCheck className="icon" />
                        </div>
                        <div className="text">
                            <h3>Fully Regulated Brokerage</h3>
                            <p>We’re licensed and fully compliant across multiple jurisdictions to ensure the highest levels of integrity</p>
                        </div>
                    </div>
                </div>

                <div className="column2">
                    <div className="column-content">
                        <div className="icon-box">
                            <FaCheck className="icon" />
                        </div>
                        <div className="text">
                            <h3>Advanced Trading Tools</h3>
                            <p>State-of-the-art trading tools created by our in-house team to enhance the success of traders at all experience levels.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="below-hero-section">
                <h2>Frequently asked Question</h2>
                <p>
                Monotonectally productivate virtual benefits vis-a-vis clicks ship. Seamlessly generate user friendly
                </p>
            </div>

           {/* FAQ Section with Two Columns */}
           <div className="faq-section">
        <div className="faq-two-column">
            {/* Left: FAQ Accordion */}
            <div className="faq-left">
                
                {faqData.map((item, index) => (
                    <div key={index} className="faq-item">
                        <div className="faq-question" onClick={() => toggleAccordion(index)}>
                            <span>{activeIndex === index ? "➖" : "➕"}</span>
                            <h3>{item.question}</h3>
                        </div>
                        <div className={`faq-answer ${activeIndex === index ? "open" : ""}`}>
                            {activeIndex === index && <p>{item.answer}</p>}
                        </div>
                    </div>
                ))}
            </div>

            {/* Right: FAQ Image */}
            <div className="faq-right">
                <img src={faqImage} alt="FAQ Illustration" className="faq-image" />
            </div>
        </div>
    </div>

            <Footer />
        </>
    );
};

export default About;
